export const IconPhone = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_65_18808)">
        <path d="M7.805 9.78716C8.58695 11.1609 9.7246 12.2986 11.0983 13.0805L11.835 12.0488C11.9535 11.8829 12.1286 11.7662 12.3273 11.7208C12.526 11.6753 12.7345 11.7043 12.9133 11.8022C14.0919 12.4463 15.3935 12.8336 16.7325 12.9388C16.9415 12.9554 17.1365 13.0501 17.2788 13.2041C17.421 13.3581 17.5 13.56 17.5 13.7697V17.488C17.5 17.6943 17.4235 17.8933 17.2853 18.0465C17.1471 18.1997 16.9569 18.2961 16.7517 18.3172C16.31 18.363 15.865 18.3855 15.4167 18.3855C8.28333 18.3855 2.5 12.6022 2.5 5.46883C2.5 5.0205 2.5225 4.5755 2.56833 4.13383C2.58938 3.92858 2.68582 3.73843 2.83899 3.60019C2.99216 3.46195 3.19117 3.38545 3.3975 3.3855H7.11583C7.32547 3.38547 7.52741 3.46446 7.6814 3.60671C7.83539 3.74896 7.93011 3.94402 7.94667 4.153C8.05185 5.49199 8.43923 6.79356 9.08333 7.97216C9.18122 8.15097 9.21018 8.35945 9.16472 8.55816C9.11927 8.75687 9.00255 8.93203 8.83667 9.0505L7.805 9.78716ZM5.70333 9.23966L7.28667 8.10883C6.83732 7.13891 6.52946 6.10953 6.3725 5.05216H4.175C4.17 5.1905 4.1675 5.32966 4.1675 5.46883C4.16667 11.6822 9.20333 16.7188 15.4167 16.7188C15.5558 16.7188 15.695 16.7163 15.8333 16.7105V14.513C14.776 14.356 13.7466 14.0482 12.7767 13.5988L11.6458 15.1822C11.1906 15.0053 10.7483 14.7964 10.3225 14.5572L10.2742 14.5297C8.63965 13.5994 7.28607 12.2458 6.35583 10.6113L6.32833 10.563C6.08909 10.1372 5.88024 9.69495 5.70333 9.23966Z" fill="#979797"/>
      </g>
      <defs>
        <clipPath id="clip0_65_18808">
          <rect width="20" height="20" fill="white" transform="translate(0 0.885498)"/>
        </clipPath>
      </defs>
    </svg>
  );
};
